module.exports = __webpack_public_path__ + "static/media/Bounced.9ef7e11f.svg";